import { render, staticRenderFns } from "./group-permissions.vue?vue&type=template&id=5d67c448&scoped=true"
import script from "./group-permissions.vue?vue&type=script&lang=js"
export * from "./group-permissions.vue?vue&type=script&lang=js"
import style0 from "./group-permissions.vue?vue&type=style&index=0&id=5d67c448&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_ckru7f3yypsoan6edyu23zfbiq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d67c448",
  null
  
)

export default component.exports